import { render } from "./NomorSuratInput.vue?vue&type=template&id=2343ae2e&scoped=true"
import script from "./NomorSuratInput.vue?vue&type=script&lang=js"
export * from "./NomorSuratInput.vue?vue&type=script&lang=js"

import "./NomorSuratInput.vue?vue&type=style&index=0&id=2343ae2e&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2343ae2e"]])

export default __exports__